let globalID
let sliderEl
let slideEl

function checkPageUntilSliderAdded () {
  sliderEl = document.querySelector('.fs-slider_v2_5-feed')
  if (!sliderEl) sliderEl = document.querySelector('.fs-slider_v2_6-feed')
  slideEl = document.querySelector('.fs-entry-container')

  if (sliderEl && slideEl) {
    document.dispatchEvent(new CustomEvent('foursixtySliderAdded'))
    return
  }

  globalID = requestAnimationFrame(checkPageUntilSliderAdded)
}

document.addEventListener('foursixtySliderAdded', () => {
  cancelAnimationFrame(globalID)
  addAdditionalSlide()
})

function addAdditionalSlide () {
  const newElement = document.createElement('div')
  newElement.className = 'fs-entry-container'
  newElement.innerHTML = `
  <div class="fs-additional-slide">
    <div class="fs-additional-slide-kicker">${
      window.BAO.foursixty.slider_additional_slide_kicker
    }</div>
    <div class="fs-additional-slide-title">${
      window.BAO.foursixty.slider_additional_slide_title
    }</div>
    ${
      window.BAO.foursixty.slider_additional_slide_link_url
        ? `<a class="btn-Button btn-Button-underline" href="${window.BAO.foursixty.slider_additional_slide_link_url}">${window.BAO.foursixty.slider_additional_slide_link_label}</a>`
        : ''
    }
  </div>
  `

  sliderEl.children[0].insertAdjacentElement('afterEnd', newElement)
}

document.addEventListener('DOMContentLoaded', () => {
  checkPageUntilSliderAdded()
})
